import { render, staticRenderFns } from "./domaine-ramonet.vue?vue&type=template&id=285895b8&scoped=true"
import script from "./domaine-ramonet.vue?vue&type=script&lang=js"
export * from "./domaine-ramonet.vue?vue&type=script&lang=js"
import style0 from "./domaine-ramonet.vue?vue&type=style&index=0&id=285895b8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "285895b8",
  null
  
)

export default component.exports